import { asyncActionsCreator } from '../../global/redux';
import * as constants from './constants';

export const getConfig = asyncActionsCreator(constants.GET_CONFIG);
export const setConfig = asyncActionsCreator(constants.SET_CONFIG);
export const getCardPayment = asyncActionsCreator(constants.GET_CARD_PAYMENT);
export const setCardPayment = asyncActionsCreator(constants.SET_CARD_PAYMENT);
